import {
  ADD_AREA_ENTRY_STRATEGY,
  ADD_AREA_ENTRY_STRATEGY_FAILED,
  ADD_AREA_ENTRY_STRATEGY_SUCCESSFUL,
} from './actionTypes';

export const addAreaEntryStrategy = ({ token, updatedBy, strategyId, rcsArea, sortOrder, history }) => ({
  type: ADD_AREA_ENTRY_STRATEGY,
  payload: { token, updatedBy, strategyId, rcsArea, sortOrder, history },
});

export const addAreaEntryStrategySuccessful = (message) => ({
  type: ADD_AREA_ENTRY_STRATEGY_SUCCESSFUL,
  payload: message,
});

export const addAreaEntryStrategyFailed = (error) => ({
  type: ADD_AREA_ENTRY_STRATEGY_FAILED,
  payload: error,
});
